export const LOAD_PROCESS_STATEMENT_RTF_SUCCESS = 'LOAD_PROCESS_STATEMENT_RTF_SUCCESS';

export const loadProcessStatementRtfSuccess = ({ rtfTemplate }) => ({
    type: LOAD_PROCESS_STATEMENT_RTF_SUCCESS,
    payload: { rtfTemplate },
});
